module.exports = __webpack_public_path__ + "static/media/notifications.e6cc2d3d.svg";